export default {"src":"/_next/static/media/proximite.36f0b1b8.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};